module.exports = __webpack_public_path__ + "static/media/pk.fbfb5582.svg";